import type {ListSuppliersSearchInput} from "./list-suppliers.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listSuppliersQueryOptions} from "./list-suppliers.query-options";

export function useListSuppliers(search: ListSuppliersSearchInput) {
  return useQuery({...listSuppliersQueryOptions(search), placeholderData: keepPreviousData});
}
